import { InjectionToken, Type } from "@angular/core";
import { EOnboardingType } from "@app/shared/onboarding/enums/onboarding.enums";

/**
 * How many minutes before the planned pick-up a Scheduled movement can be confirmed.
 * Mirrors `MOVEMENT_CONFIRM_LEAD_MINUTES` in fleet-service; used only to tell the user when Confirm opens.
 */
export const MOVEMENT_CONFIRM_LEAD_MINUTES = 10;

/**
 * The onboarding type each movement action runs: Close runs the vehicle's check-in, Confirm its check-out.
 */
export const MOVEMENT_ACTION_ONBOARDING_TYPE = {
  close: EOnboardingType.NonRevenueCheckIn,
  confirm: EOnboardingType.NonRevenueCheckOut,
} as const;

/**
 * The component the Confirm action shows beside the onboarding steps. The movements route provides it, so the flow
 * service does not import the component and its kernel inputs.
 */
export const CONFIRM_SECTION_COMPONENT = new InjectionToken<Type<unknown>>("CONFIRM_SECTION_COMPONENT");
